import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import DrinkRewardRulesTable, {
  tableColumns
} from 'components/tables/DrinkRewardRulesTable';
import { errorHandler } from 'helpers/response-utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const RewardDrinkList = () => {
  const nav = useNavigate();
  const [rewardRules, setRewardRules] = useState([]);
  const token = localStorage.getItem('token');

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/reward-drink`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }

    setRewardRules(response.data['data']['rewardRules']);
  };

  const handleDeleteRecord = async (id: number) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_ENDPOINT}/reward-drink/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    toast.success(response.data['message']);
    getList();
  };

  const table = useAdvanceTable({
    data: rewardRules,
    columns: tableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      deleteRecord: handleDeleteRecord,
      navigateToEdit: (id: number) => nav(`/reward-rules/drink/${id}/edit`)
    }
  });

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };
  const navigateToCreateLead = () => {
    nav('/reward-rules/drink/add');
  };
  return (
    <div>
      <div className="mb-6">
        <AdvanceTableProvider {...table}>
          <h2 className="mb-4">{rewardRules.length} Rules</h2>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto">
              <Button
                variant="primary"
                className="me-4"
                startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
                onClick={navigateToCreateLead}
              >
                Create Reward Rule
              </Button>
            </Col>
            <Col xs="auto">
              <div className="d-flex">
                <SearchBox
                  placeholder="Search by name"
                  className="me-2"
                  onChange={handleSearchInputChange}
                />
              </div>
            </Col>
          </Row>
          <DrinkRewardRulesTable />
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default RewardDrinkList;
